import React from 'react';
import KPL from '../components/KPL';

const LandingPage = () => {
  return (
    <KPL />
  );
};

export default LandingPage;